import { DateRange } from "../types/common";
import {
  MemberShipCardInfo,
  MemberShipCardUsageItem,
} from "../types/memberShipCardTypes";

import request from "../libs/request";

export const getMemberShipInfo = () =>
  request.get<MemberShipCardInfo>("/membership-card");

export const getMemberShipUsage = (params: DateRange) =>
  request.get<MemberShipCardUsageItem[]>("/idCard/usage", {
    params: { ...params },
  });

/**
 * 스마트 올리브 postMessage (Jira #1388)
 * 1. 새로고침
 *    1) 요청 : refreshSmartOlive
 *    2) 응답 : 없음
 * 2. 뒤로가기
 *    1) 요청 : backSmartOlive
 *    2) 응답
 *       - emptyHistory : 더이상 뒤로갈 페이지가 없는 경우
 *       - historyBack : 정상적으로 페이지가 뒤로 간 경우
 */
export const navigateSmartOliveState = {
  serviceName: "올리브식권 잔액조회",
  targetOrigin: "https://mobile.oliveticket.co.kr",
  refreshMessage: "refreshSmartOlive",
  backMessage: "backSmartOlive",
};
